// extracted by mini-css-extract-plugin
export default {"hidden":"SettingsForm_hidden__m2D6G","tryAgain":"SettingsForm_tryAgain__cZKlW","disclaimer":"SettingsForm_disclaimer__loVxT"};